module.exports = __webpack_public_path__ + "static/media/f_hairstyle_tightcurls_medium_front_shadow.ecfc7468.png";